import type { CSSProperties, ElementType, FC, ReactNode } from 'react'

import { cn } from '@/lib/utils'
import { useInView } from '@/hooks/use-in-view'

interface RevealProps {
    as?: ElementType
    delay?: number
    className?: string
    style?: CSSProperties
    id?: string
    children: ReactNode
}

// Fades and rises its children once they scroll into view.
export const Reveal: FC<RevealProps> = ({
    as: Component = 'div',
    delay = 0,
    className,
    style,
    id,
    children
}): ReactNode => {
    const { ref, inView } = useInView<HTMLElement>()

    return (
        <Component
            ref={ref}
            id={id}
            data-shown={inView}
            className={cn('fc-reveal', className)}
            style={delay ? { ...style, transitionDelay: `${delay}ms` } : style}
        >
            {children}
        </Component>
    )
}
